import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

type DrawerProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  avatar?: React.ReactNode;
  onClose: () => void;
};

const Drawer: React.FC<DrawerProps> = ({ title, subtitle, avatar, onClose, children }) => {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <aside className="drawer" role="dialog" aria-modal="true">
        <div className="drawer__head">
          {avatar}
          <div style={{ minWidth: 0 }}>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button className="btn--ghost btn--icon drawer__close" onClick={onClose} aria-label="Close details">
            <FiX />
          </button>
        </div>
        <div className="drawer__body">{children}</div>
      </aside>
    </>
  );
};

export default Drawer;
